import { tenantLogoUrl } from "@/lib/api";

const escapeHtml = (value) => String(value ?? "")
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;").replace(/'/g, "&#39;");

// Cabeçalho das etiquetas impressas: logo e nome da empresa do usuário, nunca de outra.
export function labelBrand(user) {
  const name = (user?.tenant_name || "").trim();
  const logo = user?.tenant_has_logo && user?.tenant_id ? tenantLogoUrl(user.tenant_id) : null;
  const html = `${logo ? `<img class="logo" src="${escapeHtml(logo)}" alt=""/>` : ""}${name ? `<span>${escapeHtml(name)}</span>` : ""}`;
  return { name, logo, html, hasBrand: Boolean(name || logo) };
}

export { escapeHtml };
